<template>
    <div>
        <v-footer class="footer hidden-sm-and-down" layout="row">
            <span class="grey--text" flex>&copy;  NATIONAL ELTEREVERTRIEDUNG 2019</span>
            <span flex></span>
            <a href="#">{{$t('_.about')}}</a>
            <a @click.prevent="$router.push({name: 'legal-notice'})" href="#" class="ml-3">{{$t('_.legal')}}</a>
            <a v-if="connected" @click.prevent="feedbackDialog = true" href="#" class="ml-3">{{$t('_.feedback')}}</a>
        </v-footer>
        <v-footer class="footer hidden-md-and-up mt-2" layout="column" layout-align="center center">
            <span class="grey--text">&copy;  NATIONAL ELTEREVERTRIEDUNG 2019</span>
            <div layout="row" layout-align="center center" class="mb-1">
                <a href="#">{{$t('_.about')}}</a>
                <a @click.prevent="$router.push({name: 'legal-notice'})" href="#" class="ml-3">{{$t('_.legal')}}</a>
                <a v-if="connected" @click.prevent="feedbackDialog = true" href="#" class="ml-3">{{$t('_.feedback')}}</a>
            </div>
        </v-footer>
        <v-dialog
            v-model="feedbackDialog"
            max-width="700"
            :fullscreen="$vuetify.breakpoint. smAndDown"
            >
            <v-card>
                <v-card-title class="title">
                    <div layout="row" layout-align="start center" class="full-width">
                        <v-icon color="secondary" class="mr-2">mdi-comment-text</v-icon>
                        <div layout="row" layout-align="start center" layout-wrap>{{$t('_.feedback')}}</div>
                        <v-spacer></v-spacer>
                        <v-btn class="ma-0" icon @click="feedbackDialog = false">
                            <v-icon>close</v-icon>
                        </v-btn>
                    </div>
                </v-card-title>
                <v-card-text>
                   <v-textarea
                        hide-details
                        :placeholder="$t('_.feedback_details')"
                        class="full-width" v-model="feedback"
                    ></v-textarea>
                </v-card-text>
                <v-card-actions class="pa-3">
                <v-spacer></v-spacer>
                <v-btn :disabled="!feedback" depressed color="secondary" @click="send()" style="text-transform: none">{{$t('_.validate')}}</v-btn>
                &nbsp;{{$t('_.or')}}&nbsp;
                <a @click.prevent="feedbackDialog = false" href="#" class="black--text">{{$t('_.cancel')}}</a>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    import Auth from '~/plugins/auth'
    import EventBus from '@/plugins/eventbus'
    import Feedbacks from '@/api/feedbacks'

    export default {
        data () {
            return {
                connected: false,
                feedbackDialog: false,
                feedback: ''
            }
        },
        mounted () {
            this.loadUser();
            EventBus.$on('user-changed', this.loadUser);
        },
        destroyed () {
            EventBus.$off('user-changed');
        },
        methods: {
            loadUser(){
                if(Auth.user){
                    this.connected = true;
                } else{
                    this.connected = false;
                }
            },
            send(){
                Feedbacks.create({feedback: this.feedback}).then(() => {
                    this.feedbackDialog = false;
                    this.$snotify.success(this.$t('_.feedback_sent'));
                });
            }
        }
    }
</script>

<style scoped>
.footer {
  background: white !important;
  padding: 4px 16px;
  height: 30px !important;
}
.footer > a {
  color: #333333;
}
</style>